import React from "react";
import "./listItem.css";
import ELink from "../Link/link";

const ListItem = (props) => {
  const { url, title, external, linkProps } = props;
  return (
    <li>
      <ELink
        title={title}
        external={external}
        url={url}
        linkProps={linkProps}
      />
    </li>
  );
};

export default ListItem;
